import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { OnboardingCardIds } from '@vdms-hq/api-contract';
import { configureOnboarding, ONBOARDING_PATH } from '@vdms-hq/onboarding';
import { USER_SETTINGS_ROUTER_BASE } from '@vdms-hq/user-settings';
import { TourGuideService } from '@vdms-hq/tour-guide';
import { TourService, TourState } from 'ngx-ui-tour-core';

/** Where the hub hands the user back to the app, and where the tour has anchors to point at. */
const VIDA_HOME = '/home';

/** Factories run in injection context and return closures the guard and hub call later. */
export const vidaOnboardingProviders = () =>
  configureOnboarding({
    cards: [...OnboardingCardIds],
    completeRedirect: VIDA_HOME,
    appName: 'VIDA',
    securitySettingsRoute: [USER_SETTINGS_ROUTER_BASE.ROOT, USER_SETTINGS_ROUTER_BASE.SECURITY],
    bypass: () => {
      const tour = inject(TourService);
      return () => tour.getStatus() === TourState.ON;
    },
    cardActions: () => {
      const guide = inject(TourGuideService);
      const router = inject(Router);

      return {
        /**
         * Leave the hub BEFORE starting the tour. Its steps point at `tourAnchor` targets on the app
         * shell — the client switcher, the cart, the user panel — and the hub route strips all of
         * that, so a tour started here highlights nothing and orients the user on the page they are
         * about to leave.
         *
         * Only start it if the navigation actually happened. A user still held by a required card
         * gets a refused navigation, and a tour with no anchors is worse than no tour.
         */
        tour: async () => {
          const left = await router.navigateByUrl(VIDA_HOME);
          if (left) {
            guide.runGuideFromHub(ONBOARDING_PATH);
          }
        },
      };
    },
  });
